module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/urbania_mobile.33ccce9d.svg";